import { useState, useCallback } from 'react';

export interface EmailDraft {
  to: string;
  subject: string;
  body: string;
  timestamp?: string;
}

export const useEmailMode = () => {
  const [isEmailMode, setIsEmailMode] = useState(false);
  const [emailDraft, setEmailDraft] = useState<EmailDraft>({
    to: '',
    subject: '',
    body: ''
  });

  const toggleEmailMode = useCallback(() => {
    setIsEmailMode(prev => !prev);
    // Reset draft when switching modes
    if (isEmailMode) {
      setEmailDraft({
        to: '',
        subject: '',
        body: ''
      });
    }
  }, [isEmailMode]);

  const updateEmailDraft = useCallback((updates: Partial<EmailDraft>) => {
    setEmailDraft(prev => ({
      ...prev,
      ...updates,
      timestamp: new Date().toLocaleTimeString()
    }));
  }, []);

  const resetEmailDraft = useCallback(() => {
    setEmailDraft({
      to: '',
      subject: '',
      body: ''
    });
  }, []);

  const createEmailMessage = useCallback(() => {
    if (!emailDraft.to || !emailDraft.subject || !emailDraft.body) {
      return null;
    }

    // Format as structured message that will be properly parsed
    return JSON.stringify({
      type: 'email',
      data: emailDraft,
      timestamp: new Date().toISOString()
    });
  }, [emailDraft]);

  return {
    isEmailMode,
    emailDraft,
    toggleEmailMode,
    updateEmailDraft,
    resetEmailDraft,
    createEmailMessage
  };
};